<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'clientes'"><CrudClientes /></div>
    <div v-if="view === 'servicios'"><CrudServicios /></div>
    <div v-if="view === 'pedidos'"><CrudPedidos /></div>
    <div v-if="view === 'disenos'"><CrudDisenos /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import CrudClientes from "@/components/TableroProduccion/CrudClientes.vue";
import CrudServicios from "@/components/TableroProduccion/CrudServicios.vue";
import CrudPedidos from "@/components/TableroProduccion/Pedidos/CrudPedidos.vue";
import CrudDisenos from "@/components/TableroProduccion/Disenos/CrudDisenos.vue";

const view = ref("pedidos");
</script>
